import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const mobileApiErrorTypeValues = ["INVALID_API_KEY"] as const;

const mobileApiErrorTypeSchema = z.enum(mobileApiErrorTypeValues);
const MobileApiErrorType = mobileApiErrorTypeSchema.enum;
type MobileApiErrorType = z.infer<typeof mobileApiErrorTypeSchema>;

export type MobileApiErrors = {
  errorType: typeof MobileApiErrorType.INVALID_API_KEY;
  data: undefined;
};

export const mobileApiErrorDetails: Record<MobileApiErrorType, ErrorDetails> = {
  [MobileApiErrorType.INVALID_API_KEY]: {
    sentryDescription: "Invalid API key provided",
    remiHttpCode: RemiHttpCode.UNAUTHORIZED,
  },
};
